export default __webpack_public_path__ + "media/complete-missions2x.cf93a11b.png";